export default __webpack_public_path__ + "static/media/customerio.f6ec0294.svg";